export class ContactEventTagBuilder {
  
  private eventCategory: string;
  private eventAction: string;
  private eventLabel: string;
  private isWhatsApp: boolean;

  public constructor(isWhatsApp = false) {
    this.isWhatsApp = isWhatsApp;
  }

  fromAgentPage(): ContactEventTagBuilder {
    this.eventCategory = 'pagina:corretor';
    return this;
  }

  toShareClick(): ContactEventTagBuilder {
    this.eventAction =  'clique:compartilhar';
    return this;
  }

  toContactClick(): ContactEventTagBuilder {
    this.eventAction = this.isWhatsApp ? 'clique:whatsapp' : 'clique:contato';
    this.eventLabel = '';
    return this;
  }

  toCallbackAction(): ContactEventTagBuilder {
    this.eventAction = 'callback:contato';
    return this;
  }

  withLabel(label: string): ContactEventTagBuilder {
    this.eventLabel = label;
    return this;
  }

  public build(): any {
    return {
      event: 'click',
      eventCategory: this.eventCategory,
      eventAction: this.eventAction,
      eventLabel: this.eventLabel
    }
  }

}